"use client"

import type React from "react"

import { useState } from "react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Label } from "../../../components/ui/label"
import { Textarea } from "../../../components/ui/textarea"
import { Settings, Eye } from "lucide-react"

export function SiteSettingsSection({allUsers,adminUsers,comments}:any) {
  const [settings, setSettings] = useState({
    siteTitle: "TSO Ministries",
    logo: "https://tsoministries.com/wp-content/uploads/2025/02/logo.png",
    contactEmail: "admin@tsoministries.com",
    contactPhone: "",
    footerText: "© 2025 TSO-MINISTRIES. All rights reserved.",
  })

  const handleSettingChange = (field: string, value: string) => {
    setSettings((prev) => ({ ...prev, [field]: value }))
  }

  const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const logoUrl = URL.createObjectURL(file)
      setSettings((prev) => ({ ...prev, logo: logoUrl }))
    }
  }

  const saveSettings = () => {
    console.log("Saving site settings:", settings)
  }

  const previewSite = () => {
    window.open("/", "_blank")
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="flex items-center gap-2">
                <Settings className="h-5 w-5" />
                General Site Settings
              </CardTitle>
              <CardDescription>Configure basic site information and branding</CardDescription>
            </div>
            <Button variant="outline" onClick={previewSite}>
              <Eye className="h-4 w-4 mr-2" />
              Preview Site
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid gap-6 md:grid-cols-2">
            <div className="space-y-4">
              <div>
                <Label htmlFor="site-title">Site Title</Label>
                <Input
                  id="site-title"
                  value={settings.siteTitle}
                  onChange={(e) => handleSettingChange("siteTitle", e.target.value)}
                  placeholder="Enter your ministry name"
                />
              </div>

              <div>
                <Label htmlFor="contact-email">Contact Email</Label>
                <Input
                  id="contact-email"
                  type="email"
                  value={settings.contactEmail}
                  onChange={(e) => handleSettingChange("contactEmail", e.target.value)}
                  placeholder="contact@ministry.com"
                />
              </div>

              <div>
                <Label htmlFor="contact-phone">Contact Phone</Label>
                <Input
                  id="contact-phone"
                  type="tel"
                  value={settings.contactPhone}
                  onChange={(e) => handleSettingChange("contactPhone", e.target.value)}
                  placeholder="+1 (555) 123-4567"
                />
              </div>

              <div>
                <Label htmlFor="footer-text">Footer Text</Label>
                <Textarea
                  id="footer-text"
                  value={settings.footerText}
                  onChange={(e) => handleSettingChange("footerText", e.target.value)}
                  placeholder="Enter footer text"
                  rows={3}
                />
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <Label htmlFor="logo">Site Logo</Label>
                <div className="space-y-4">
                  <Input id="logo" type="file" accept="image/*" onChange={handleLogoUpload} />

                  {settings.logo && (
                    <div className="border rounded-lg p-4 bg-muted/50">
                      <p className="text-sm font-medium mb-2">Current Logo:</p>
                      <img
                        src={settings.logo || "/placeholder.svg"}
                        alt="Site Logo"
                        className="max-w-full h-20 object-contain"
                      />
                    </div>
                  )}

                  <p className="text-xs text-muted-foreground">Recommended: PNG or SVG format, max 200px width</p>
                </div>
              </div>

              <div className="border rounded-lg p-4 bg-muted/50">
                <h4 className="font-medium mb-2">Site Preview</h4>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-medium">Title:</span> {settings.siteTitle}
                  </div>
                  <div>
                    <span className="font-medium">Email:</span> {settings.contactEmail}
                  </div>
                  <div>
                    <span className="font-medium">Phone:</span> {settings.contactPhone}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t">
            <Button onClick={saveSettings} className="w-full md:w-auto">
              Save Site Settings
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
